import { removeNullOrEmpty } from "@/common/utils";
import PaginateModel, { PaginateDTO } from "@/model/paginate";
import Property, { PropertyDTO } from "@/model/property";
import api from "./api";

interface PropertyListResponseInterface {
  meta: string;
  data: {
    data: PropertyDTO[];
    pagination: any;
  };
}

interface PropertyList {
  paginate: PaginateDTO;
  list: Property[];
}

class PropertyApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async index(query): Promise<PropertyList> {
    const data: any = {};
    if (query.notLoading) {
      data.notLoading = true;
    }
    const response = await this.getHttp().get<PropertyListResponseInterface>(
      "/properties",
      {
        params: query,
        data: data
      }
    );

    const list = response.data.data.data.map((item) => {
      return new Property(item);
    });
    const paginate = new PaginateModel({
      page: response.data.data.pagination.current_page,
      pageCount: response.data.data.pagination.last_pages,
      start: response.data.data.pagination.current_page,
      end: response.data.data.pagination.last_pages,
      count: response.data.data.pagination.total,
    });
    return {
      list,
      paginate,
    };
  }

  async getProperties(query = {}, data = {}): Promise<Property[]> {
    const response = await this.getHttp().get<any>("/properties/without-paginate", {
      data: data,
      params: query,
    });
    if (response.status === 200) {
      return response.data.data.map((item) => new Property(item));
    }
  }

  async show(id): Promise<Property> {
    const response = await this.getHttp().get<any>("/properties/" + id);

    if (response.status === 200) {
      return new Property(response.data.data);
    }
  }

  async remove(id): Promise<any> {
    return await this.getHttp().delete<any>("/properties/" + id);
  }

  async updateCompany(property: Property): Promise<any> {
    const data = {
      company_id: property.company_id,
      person_in_charge_id: property.person_in_charge_id
    };
    const response = await this.getHttp().put<any>("/properties/update-detail/" + property.id, data);
    return response.data;
  }

  async create(property: Property): Promise<any> {
    const dataProperty = property.tranformRequest();
    const response = await this.getHttp().post<any>("/properties", dataProperty);
    return response.data;
  }

  async update(property: Property): Promise<any> {
    const dataProperty = property.tranformRequest();
    const response = await this.getHttp().put<any>(
      "/properties/" + property.id,
      dataProperty
    );

    return response.data;
  }

  async bulkUpdate(propertyId: string[], property: Property): Promise<any> {
    const dataProperty = removeNullOrEmpty(property);
    const data = {
      ids: propertyId,
      ...dataProperty
    };

    const response = await this.getHttp().put<any>("/properties/bulk-edit", data);
    return response.data;
  }

  async getPropertiesForSelectItem(query): Promise<PropertyList> {
    const data: any = {};
    if (query.notLoading) {
      data.notLoading = true;
    }
    const response = await this.getHttp().get<PropertyListResponseInterface>(
      "/properties/select-item",
      {
        params: query,
        data: data
      }
    );

    const list = response.data.data.data.map((item) => {
      return new Property(item);
    });
    const paginate = new PaginateModel({
      page: response.data.data.pagination.current_page,
      pageCount: response.data.data.pagination.last_pages,
      start: response.data.data.pagination.current_page,
      end: response.data.data.pagination.last_pages,
      count: response.data.data.pagination.total,
    });
    return {
      list,
      paginate,
    };
  }
}
export default new PropertyApi();
